export const perfilKeys = {
  context: () => ["perfil", "context"],
  hijos: () => ["perfil", "hijos"],
};
